import { MutableRefObject } from 'react';

import { Field, Form, FormTheme } from '@kanda-libs/ks-component-ts';
import {
  Button,
  Loader,
  ModalContainer,
  ModalLayoutCenter,
} from '@kanda-libs/ks-design-library';

import { REQUEST_CHANGES_MODAL_ID, REQUEST_VALIDATION } from './constants';
import useRequestChangesModalForm from './useRequestChangesModal';

const RequestChangesModal: React.FunctionComponent = function () {
  const { form, onSubmit, isSubmitting } = useRequestChangesModalForm();
  return (
    <ModalContainer id={REQUEST_CHANGES_MODAL_ID} opacity={40}>
      {({ ref, handleClose }) => (
        <ModalLayoutCenter
          id={REQUEST_CHANGES_MODAL_ID}
          ref={ref as MutableRefObject<HTMLDivElement>}
          onClose={isSubmitting ? undefined : handleClose}
          className="w-11/12 max-w-128"
        >
          <Form form={form} id="request-quote-changes" onSubmit={onSubmit}>
            <FormTheme variant="streamline">
              <div className="flex flex-col gap-y-4">
                <div className="w-full pr-8">
                  <h2 className="text-16-24-em md:text-20-24-em">
                    Something not quite right on your quote?
                  </h2>
                </div>
                <h3 className="text-14-22">
                  Let us know below and we&apos;ll inform your tradesperson for
                  you.
                </h3>
                <Field.Validator validation={REQUEST_VALIDATION}>
                  <Field.TextAreaInput
                    type="textarea"
                    name="reason"
                    rows={5}
                    placeholder="Provide some details of what issues there are with this quote, and we'll let your tradesperson know..."
                  />
                </Field.Validator>
                <div className="flex flex-col-reverse sm:flex-row -mt-4 gap-x-3 gap-y-3">
                  <Button.Text
                    id="request-changes-cancel"
                    variant="outline"
                    label={
                      <p className="text-14-22-em text-neutral-800 -mx-6">
                        Cancel
                      </p>
                    }
                    className="hover:bg-neutral-100 w-full"
                    onClick={handleClose}
                    disabled={isSubmitting}
                  />
                  <Button.Text
                    id="request-changes-submit"
                    submit
                    label="Submit Request"
                    className="w-full"
                    disabled={isSubmitting}
                  />
                </div>
              </div>
            </FormTheme>
          </Form>
          <Loader isLoading={isSubmitting} />
        </ModalLayoutCenter>
      )}
    </ModalContainer>
  );
};

export default RequestChangesModal;
